import { render, staticRenderFns } from "./addMenu.vue?vue&type=template&id=1aca276a&scoped=true"
import script from "./addMenu.vue?vue&type=script&lang=js"
export * from "./addMenu.vue?vue&type=script&lang=js"
import style0 from "./addMenu.vue?vue&type=style&index=0&id=1aca276a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aca276a",
  null
  
)

export default component.exports